import colors from 'config/theme/colors';
import { ENV_CONFIG } from 'config/environment';
import { Hero } from 'components/Hero';
import { PressSection } from 'screens/Landing/PressSection';
import { Marketing } from './Marketing';
import { Community } from './Community';
import { Recommendations } from './Recommendations';
import HeaderAndFooterLayout from 'layouts/HeaderAndFooter';
import { getStartedItemsBackup } from './constants';

export const GetStartedBackupScreen = () => {
  return (
    <HeaderAndFooterLayout
      headerVisible={false}
      isLoading={false}
      hasIssues={true}
      footerWhiteLabeled={true}
    >
      <div className="get-started-page">
        <Hero
          title="Support Causes You Care About"
          subtitle="Oath provides personalized Democratic donation recommendations so your dollars have a bigger impact."
          formContent="get-started-top-button"
          media={`${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/getstarted/get-started-hero.png`}
          bgColor={colors.oathBlue}
        />
        <div className="get-started-content">
          <Marketing
            backup
            items={getStartedItemsBackup}
            title="Oath makes it easy to make a difference."
            subtitle="If you are outraged by the Trump administration, Oath can help you turn your anger into action!"
          />
        </div>
        <Recommendations title="Join to learn where you can make a difference right now:" />
        <Community backup />
        <PressSection />
      </div>
    </HeaderAndFooterLayout>
  );
};
